import apiInputService from "services/apiInputService";
import { WorkerBySubcontractorParams } from "./@types";
import { useSubscription } from "store/auth/auth-store";
import { useQuery } from "@tanstack/react-query";



export const fetchWorksBySubcontractor = async (params: WorkerBySubcontractorParams) => {
    const { data } = await apiInputService.get("/Worker/subcontractor", { params });
    return data as any[];
}

export const useWorkersBySubcontractor = (params: WorkerBySubcontractorParams) => {
    const { subscription } = useSubscription();

    return useQuery(["workers", subscription?.subscriptionId, params], ()=> fetchWorksBySubcontractor(params), {
        refetchOnWindowFocus: true,
        enabled: !!subscription?.subscriptionId && !!params,
    });

}
    